import authRoutesDefined from './auth';
import errorRoutesDefined from './error';
import mainRoutesDefined from './main';

export const routesDefined = [
  authRoutesDefined,
  errorRoutesDefined,
  mainRoutesDefined,
];
